<template>
  <label :for="inputId" class="rwfc rwfc--select2 mb-0">
    <span class="sr-only">{{ labelText }}</span>
    <select
      :name="inputName"
      :id="inputId"
      class="select2"
      ref="select"
      v-model="localValue"
      multiple="multiple"
      autocomplete="nope"
    >
      <slot :options="options" name="options"></slot>
    </select>
  </label>
</template>

<script>

export default {
  props: {
    zipcodes: {},
    value: {
      type: Array,
    },
    selected: {},
    inputName: {
      type: String,
      required: true,
    },
    inputId: {
      type: String,
      required: true,
    },
    labelText: {
      type: String,
      required: true,
    },
    endpoint: {
      type: String,
    },
    options: {},
    ajax: {
      default: false,
    },
    placeHolderText: {
      default: 'Start Typing'
    }
  },

  data() {
    const vm = this;
    return {
      debug: true,
      changing: false,
      initialized: false,
      selected_zipcodes: [],
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit("input", localValue);
      },
    },
    config() {
      const vm = this;

      let config = {
        // minimumInputLength: 2,
        // templateResult: vm.formatResults,
        placeholder: vm.placeHolderText,
        multiple: true,
      };

      if (this.ajax && this.endpoint) {
        config.ajax = {
          type: "GET",
          delay: 500,
          url: this.endpoint,
          dataType: "json",
          language: {
            inputTooShort: function () {
              return "testng";
            },
          },
          data: function (params) {
            return {
              term: params.term, // search term
            };
          },
          processResults: function (data) {
            return {
              results: data.map((result) => {
                return {
                  id: result.id,
                  text: result.id,
                };
              }),
            };
          },
          error: function (jqXHR, status, error) {
            return { results: [] };
          },
        };
      }

      return config;
    },
  },
  mounted() {
    this.init()
  },

  methods: {
    init(){
      console.log('init');
      var vm = this;
      $(this.$refs.select)
        // init select2
        .select2(this.config)
        .val(this.value)
        .trigger("change")
        // emit event on change.
        .on("change", function () {
          if (vm.changing) {
            vm.changing = false;
            return false;
          }
          vm.initialized = true;
          let newVal = $(this).val();
          if (newVal == null) {
            newVal = [];
          }
          vm.$emit("input", newVal);
        })
        .on('select2:unselect', function(e){
          /**
           * DO NOT REMOVE THIS!!!!
           * - THIS IS HERE FOR A REASON, i know it doesnt make sense.
           * - This is here to fix a bug that was causing the page to stop scrolling after an option was cleared from within Select2 Multiple
           */
          try {
            $(vm.$refs.select).select2()
          } catch (error) {
            console.warn(error)
          }
        });
      
    },
    /**
     * Take all of the <option> values in the <select>, and return their values in an array
     */
    getValuesFromMultiSelect(select, selectedValues) {
      var result = [];
      var options = select && select.options;
      var opt;
      for (var i = 0, iLen = options.length; i < iLen; i++) {
        result.push(options[i].value);
      }
      return result;
    },
    formatResults(result) {
      return result.text;
    },
    removeOptions(selectElement) {
      var i, L = selectElement.options.length - 1;
      for(i = L; i >= 0; i--) {
          selectElement.remove(i);
      }
    }
  },
  watch: {
    /**
     * This is needed so that we can detect when the values change programatically after the component has already initialized
     */
    value(value) {
      const vm = this;
      vm.changing = true;
      
      /**
       * Take all of the <option> values in the <select>, and return their values in an array
       */
      let valuesArray = vm.getValuesFromMultiSelect(vm.$refs.select, value);

      // remove options from within the dropdown. we are about to insert a fresh sset
      this.removeOptions(this.$refs.select)

      for (let index in valuesArray) {
        if (valuesArray[index] == "") continue;

        let value = valuesArray[index];
        let text = this.options.find(o => o.id == value)?.text;
        let selected = valuesArray.includes(valuesArray[index])

        let option = new Option(
          text, // text / innerHTML
          value, // value / option.value
          selected, // defaultSelected
          selected // selected
        );
        vm.$refs.select.append(option);
      }

      $(vm.$refs.select).select2(vm.config).val(value).trigger("change");

      return value;
    },
  },
};
</script>

<style>
</style>